/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { IconRenderProps } from "@/src/types/IconRenderProps.ts";

export default function IconCode({ width = 32, height = 32, fill }: IconRenderProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5333 22.1333L6.4 16L12.5333 9.86667L10.6667 8L2.66666 16L10.6667 24L12.5333 22.1333ZM19.4667 22.1333L25.6 16L19.4667 9.86667L21.3333 8L29.3333 16L21.3333 24L19.4667 22.1333Z"
        fill="current"
      />
    </svg>
  );
}
